import { makeAdUnitPath } from '@/utils/ads';
import type { TargetingKeyValues } from '@/types/ads';
import type { ClientSiteConfig } from '@/temporary-site-config';

import type { Article } from '../ArticleList/types';

export const makeUrl = (params: TargetingKeyValues): string => {
	const query = Object.entries(params)
		.map(([k, v]) => `${k}=${v}`)
		.join('&');
	return `https://pubads.g.doubleclick.net/gampad/ads?${query}`;
};

export const vastCustomParams = (
	placement: TargetingKeyValues,
	page: TargetingKeyValues,
): string => {
	return encodeURIComponent(
		Object.entries({ ...page, ...placement })
			.map(([k, v]) => `${k}=${v}`)
			.join('&'),
	);
};

export const generateVastTag = ({
	config,
	currentPost,
	modelTargeting,
	pageTargeting,
	path,
	videoPlatformId,
}: {
	config: ClientSiteConfig;
	currentPost: Article | undefined;
	modelTargeting: TargetingKeyValues;
	pageTargeting: TargetingKeyValues;
	path: string;
	videoPlatformId: string;
}): string => {
	const currentLocation = window.location.href;
	const vastParams: TargetingKeyValues = {
		ad_rule: '1',
		cmsid: config.channelKey,
		correlator: pageTargeting.correlator,
		cust_params: vastCustomParams(modelTargeting, pageTargeting),
		description_url: currentLocation,
		env: 'vp',
		gdfp_req: '1',
		impl: 's',
		iu: makeAdUnitPath(currentPost, path, config),
		output: 'vmap',
		plcmt: '2',
		sz: '940x529',
		unviewed_position_start: '1',
		url: currentLocation,
		vid: videoPlatformId,
		vpmute: '1',
		vpos: 'preroll',
	};

	return makeUrl(vastParams);
};
